"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardLoader = void 0;
const ColoniesCardManifest_1 = require("./cards/colonies/ColoniesCardManifest");
const PreludeCardManifest_1 = require("./cards/prelude/PreludeCardManifest");
const PromoCardManifest_1 = require("./cards/promo/PromoCardManifest");
const StandardCardManifests_1 = require("./cards/StandardCardManifests");
const TurmoilCardManifest_1 = require("./cards/turmoil/TurmoilCardManifest");
const VenusCardManifest_1 = require("./cards/venusNext/VenusCardManifest");
const CommunityCardManifest_1 = require("./cards/community/CommunityCardManifest");
const AresCardManifest_1 = require("./cards/ares/AresCardManifest");
const CardName_1 = require("./CardName");
const GameModule_1 = require("./GameModule");
const MoonCardManifest_1 = require("./cards/moon/MoonCardManifest");
const LeaderCardManifest_1 = require("./cards/leaders/LeaderCardManifest");
const PreludeTwoCardManifest_1 = require("./cards/preludeTwo/PreludeTwoCardManifest");
class CardLoader {
    constructor(gameOptions) {
        this.gameOptions = gameOptions;
        const manifests = [
            [true, StandardCardManifests_1.BASE_CARD_MANIFEST],
            [gameOptions.corporateEra, StandardCardManifests_1.CORP_ERA_CARD_MANIFEST],
            [gameOptions.preludeExtension, PreludeCardManifest_1.PRELUDE_CARD_MANIFEST],
            [gameOptions.preludeTwoExtension, PreludeTwoCardManifest_1.PRELUDE_TWO_CARD_MANIFEST],
            [gameOptions.venusNextExtension, VenusCardManifest_1.VENUS_CARD_MANIFEST],
            [gameOptions.coloniesExtension, ColoniesCardManifest_1.COLONIES_CARD_MANIFEST],
            [gameOptions.turmoilExtension, TurmoilCardManifest_1.TURMOIL_CARD_MANIFEST],
            [gameOptions.aresExtension, AresCardManifest_1.ARES_CARD_MANIFEST],
            [gameOptions.promoCardsOption, PromoCardManifest_1.PROMO_CARD_MANIFEST],
            [gameOptions.communityCardsOption, CommunityCardManifest_1.COMMUNITY_CARD_MANIFEST],
            [gameOptions.moonExpansion, MoonCardManifest_1.MOON_CARD_MANIFEST],
            [gameOptions.leadersExpansion, LeaderCardManifest_1.LEADER_CARD_MANIFEST],
        ];
        this.manifests = manifests.filter((a) => a[0]).map((a) => a[1]);
    }
    static include(gameOptions, cf) {
        if (cf.compatibility === undefined) {
            return true;
        }
        const expansions = Array.isArray(cf.compatibility) ? cf.compatibility : [cf.compatibility];
        return expansions.every((expansion) => {
            switch (expansion) {
                case GameModule_1.GameModule.Venus:
                    return gameOptions.venusNextExtension;
                case GameModule_1.GameModule.Prelude:
                    return gameOptions.preludeExtension;
                case GameModule_1.GameModule.Colonies:
                    return gameOptions.coloniesExtension;
                case GameModule_1.GameModule.Turmoil:
                    return gameOptions.turmoilExtension;
                case GameModule_1.GameModule.Promo:
                    return gameOptions.promoCardsOption;
                case GameModule_1.GameModule.Ares:
                    return gameOptions.aresExtension;
                case GameModule_1.GameModule.Moon:
                    return gameOptions.moonExpansion;
                case GameModule_1.GameModule.Leader:
                    return gameOptions.leadersExpansion;
                default:
                    throw new Error(`Unhandled expansion type ${expansion} for card ${cf.cardName}`);
            }
        });
    }
    addDeck(cards, deck) {
        deck.factories.forEach((cf) => {
            if (CardLoader.include(this.gameOptions, cf)) {
                cards.push(new cf.Factory());
            }
        });
    }
    getProjectCards() {
        return this.getCards((manifest) => manifest.projectCards);
    }
    getStandardProjects() {
        return this.getCards((manifest) => manifest.standardProjects);
    }
    getCorporationCards() {
        const corporationCards = this.getCards((manifest) => manifest.corporationCards);
        if (this.gameOptions.customCorporationsList.length > 0) {
            return corporationCards.filter((card) => this.gameOptions.customCorporationsList.includes(card.name));
        }
        return corporationCards.filter((card) => card.name !== CardName_1.CardName.BEGINNER_CORPORATION);
    }
    getPreludeCards() {
        let preludes = this.getCards((manifest) => manifest.preludeCards);
        if (this.gameOptions.twoCorpsVariant === true) {
            preludes = preludes.filter((p) => p.name !== CardName_1.CardName.MERGER);
        }
        if (preludes.length === 0) {
            this.addDeck(preludes, PreludeCardManifest_1.PRELUDE_CARD_MANIFEST.preludeCards);
        }
        return preludes;
    }
    getLeaderCards() {
        return this.getCards((manifest) => manifest.leaderCards);
    }
    getCards(getDeck) {
        const cards = [];
        for (const manifest of this.manifests) {
            this.addDeck(cards, getDeck(manifest));
        }
        return cards.filter((card) => {
            if (this.gameOptions.cardsBlackList.includes(card.name))
                return false;
            for (const manifest of this.manifests) {
                if (manifest.cardsToRemove.has(card.name))
                    return false;
            }
            return true;
        });
    }
}
exports.CardLoader = CardLoader;
//# sourceMappingURL=CardLoader.js.map